import { timezones } from "../../timezones";
import { defaultParseError, parseString, toString, sortLength } from "../utils";
/**
 * Date format 'e' => timezone id
 */
export class TimezoneField {
    constructor(fieldName, conversion = function (value) { return value; }) {
        this.fieldName = fieldName;
        this.conversion = conversion;
    }
    render(p) {
        if (p.resolvedTimezone) {
            return toString(this.conversion(p.resolvedTimezone[this.fieldName]));
        }
        return '???';
    }
    parse(state) {
        return parseString(state, sortLength(timezones.map((t) => toString(this.conversion(t[this.fieldName])))), null, defaultParseError(state));
    }
    get displayTimezone() {
        return true;
    }
    get displayHours() {
        return false;
    }
    get displayMinutes() {
        return false;
    }
    get displaySeconds() {
        return false;
    }
    get displayMilliseconds() {
        return false;
    }
    get displayMicroseconds() {
        return false;
    }
    get displayDate() {
        return false;
    }
    get displayMonth() {
        return false;
    }
    get displayYear() {
        return false;
    }
}
//# sourceMappingURL=TimezoneField.js.map
